var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"card-grid-operators"},[_c('div',[_c('grid',{attrs:{"newLabel":"Aggiungi","headers":_vm.headers,"CanCreate":true,"title":"Operators-Procedures","controller":"GridElement/","readAll":"GetOperatorsProcedures","create":"Create","edit":"Create","delete":"OperatorsProcedures/DeleteOperatorProcedure","hideColumns":[
            'Id',
            'Surname',
            'OperatorName',
            'OperatorId',
            'ProcedureId',
            'Mail'
          ]},on:{"refreshMenu":_vm.updateMenu}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }